import { useQuery } from '@tanstack/react-query';

import { programsApi } from '../api/programsApi';
import { segmentsApi } from '../api/segmentsApi';
import { DetailsOption } from '../types/program';
import { formatDetailsOptions } from '../utils/formatDetailsOptions';

const DEFAULT_OPTIONS = {
  instructors: [] as DetailsOption<number>[],
  types: [] as DetailsOption<number>[],
  segments: [] as DetailsOption<string>[],
};

const getInitialStepInputsOptions = async () => {
  const [initialStepInputs, instructors, segments] = await Promise.all([
    programsApi.fetchInitialStepInputs(),
    programsApi.fetchInstructors(),
    segmentsApi.fetchSegments(),
  ]);

  return {
    instructors: formatDetailsOptions(instructors),
    types: formatDetailsOptions(initialStepInputs.availableTypes),
    segments: formatDetailsOptions(segments.segments),
  };
};

export const useInitialStepOptions = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['initial-step-options'],
    queryFn: getInitialStepInputsOptions,
    refetchOnWindowFocus: false,
  });

  return {
    initialStepOptions: data || DEFAULT_OPTIONS,
    loadingOptions: isLoading,
  };
};
